import {
    SET_HVI_DATA,
  } from "../types";
  
  const initialState = {
    hvidata: {},
  };
  
  // handle actions
  export default function (state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case SET_HVI_DATA: {

        return {
          ...state,
          hvidata: payload,
        };
      }
      default:
        return state;
    }
  }
  